import img1 from "../images/avatar/avt-5.png";
import img2 from "../images/avatar/avt-4.png";
import img3 from "../images/avatar/avt-1.png";
import img4 from "../images/avatar/avt-2.png";
import img5 from "../images/avatar/avt-3.png";
import img6 from "../images/avatar/avt-6.png";
const postdata = [
  {
    img: img1,
    name: "All",
    price: "523.7 ETH",
  },
  {
    img: img2,
    name: "Electronics",
    price: "523.7 ETH",
  },
  {
    img: img3,
    name: "Stationery",
    price: "523.7 ETH",
  },
  {
    img: img4,
    name: "Books",
    price: "523.7 ETH",
  },
  {
    img: img5,
    name: "Fashions",
    price: "523.7 ETH",
  },
  {
    img: img6,
    name: "Furniture",
    price: "523.7 ETH",
  },
];

export default postdata;
